<template lang="pug">
.playcard-check-balance-container.m-b-40
  re-toast-alert.m-t-50(v-if="checkingErrorMessage" type="danger") {{ checkingErrorMessage }}

  .check-card.check-card-gift
    h3.check-card__caption Check {{PLAYCARD}} balance
    .check-card__col
      p.check-card__text {{PLAYCARD_TC}} Number
      p.check-card__text CVV
    .check-card__col
      input.check-card__inp.number(v-model="number" type="number" placeholder="XXXX XXXX XXXX XXXX")
      input.check-card__inp.code(v-model="cvv" type="password" placeholder="****" maxlength="4")
    .check-card__col
      a.check-card__link(href="" @click.prevent="$refs.whatIsNumberModal.show") What is this?
      a.check-card__link(href="" @click.prevent="$refs.whatIsCvvModal.show") What is this?
  re-content-placeholder(name="check_card_balance_below_card_number_entry")
  .check-balance__button.m-b-20
    v-button.site_button.site_button_inverse(@click="check" :loading="isChecking" :disabled="$v.$invalid" no-default-class)
      span Check {{PLAYCARD_TC}} Balance
  div(v-if="offerReload")
    p.check-balance__reload-text Would you like to
      router-link.check-balance__reload-link(:to="{ name: 'supercharged.reload-play-card' }")  reload your {{PLAYCARD_TC}}?

  substrate(v-if="showBalanceModal" @close="showBalanceModal = false" inner-class="substrate__popup-change-pass-padd")
    p.substrate__popup-change-pas__caption.substrate__popup-change-pas__caption-mod {{PLAYCARD_TC}} Balance
    .flex-rows.m-b-10
      .playcard-balance-flex-left {{PLAYCARD_TC}} Number
      .playcard-balance-flex-right {{ playcard.number }}
    .flex-rows.m-b-10
      .playcard-balance-flex-left Balance
      .playcard-balance-flex-right {{ playcard.cash + playcard.bonus_cash | currency }}
    .flex-rows.m-b-20(v-if="playcard.tickets")
      .playcard-balance-flex-left Tickets
      .playcard-balance-flex-right {{ playcard.tickets || 0 }}
    div(v-if="offerReload")
      router-link(:to="{ name: 'supercharged.reload-play-card', query: { number } }")
        button.site_button.substrate__popup-change-pass__more.substrate__button__full-w(type="button")
          span Reload this card

  what-is-modal(ref="whatIsNumberModal" :img-src="`${config.baseUri}/images/supercharged/playcard-number-example.png`")
  what-is-modal(ref="whatIsCvvModal" :img-src="`${config.baseUri}/images/supercharged/playcard-cvv-example.png`")

</template>

<script>
import axios from 'axios'
import {getQS} from '../../lib/utils'
const qs = getQS() || {}
const defaultNumber = qs.number
import { required } from 'vuelidate/lib/validators'
import { getFirstErrorMessage } from '~/lib/axios'
import ConfigMixin from '../../components/_mixins/config'
import PagesMixin from '../../components/_mixins/pages'

const EventBus = window.VueEventBus

export default {
  mixins: [
    ConfigMixin,
    PagesMixin
  ],
  props: {
    offerReload: {
      type: [String, Number, Boolean],
      default: true
    }
  },

  data: () => ({
    number: defaultNumber,
    cvv: null,

    playcard: null,

    isChecking: false,
    showBalanceModal: false,
    checkingErrorMessage: null,
  }),

  validations: {
    number: {
      required,
    },
    cvv: {
      required,
    },
  },

  methods: {
    async check() {
      try {
        const payload = {
          number: this.number,
          cvv: this.cvv,
        }
        this.isChecking = true
        const { data: { data: playcard } }  = await axios.post(`${this.config.apiUri}/customer/playcard/details`, payload)
        this.playcard = playcard
        this.showBalanceModal = true
        this.checkingErrorMessage = null

        EventBus.$emit('card.check-balance.success', playcard)
      } catch (e) {
        this.checkingErrorMessage = getFirstErrorMessage(e)
      } finally {
        this.isChecking = false
      }
    },
  },
}
</script>

<style lang="scss">
.playcard-check-balance-container {

  .playcard-balance-flex-left,
  .playcard-balance-flex-right {
    flex-basis: 50%;
  }

  .playcard-balance-flex-left {
    color: gray;
  }
  .playcard-balance-flex-right {
    color: black;
  }

  .substrate__popup-change-pass input {
    border: 1px solid #BEBEBE;
    width: 100%;
    height: 50px;
  }

  @media screen and (max-width: 375px) {
    .check-card {
      margin-left: auto;
      margin-right: auto;
    }
  }
}
</style>
